import config from "../../config/config";

import tealiumLoad from "../scriptLib/tealiumLoad";

import tealiumTrackingModel from "../model/tealiumTrackingModel";

import searchLib from "./searchLib";

import setupClickTracking from "./setupClickTracking";

import visualDebugger from "./visualDebugger";

const cleanUpPathAndText = (gizmoPath) => {
	// Clean up path and text string from Gizmo to get correct structure to work with
	let text = "";
	let triggerPath = gizmoPath.split(" --> ").map((path) => {
		let splitPath = path.split("[");
		if (splitPath.length > 1) {
			let justPath = splitPath.shift();
			text = splitPath.join("[").slice(0, -1);
			path = justPath;
		}
		path = path
			.replace(/\.gizmo-link/g, "")
			.replace(/DIV\./g, ".")
			.replace(/\.hovering/g, "");
		return path;
	});
	triggerPath[triggerPath.length - 1] = triggerPath[triggerPath.length - 1].split("[")[0];
	return {
		triggerPath,
		text,
	};
};

/*
// Different change trigger, think height is more reliable
const detectPageChangesObserve = (changeCallback) => {
    const targetNode = document.getElementById('content');
    const configObserver = { attributes: true, childList: true, subtree: true };
    const callback = (mutationList, observer) => {
        for (const mutation of mutationList) {
            if (mutation.type === 'childList' || mutation.type === 'attributes')
                changeCallback();
        }
    };
    const observer = new MutationObserver(callback);
    observer.observe(targetNode, configObserver);
    setTimeout(() => {
        observer.disconnect();
    }, 500 * 60); // 500 * 60 = Stop after 30 seconds
}
 */

const detectPageChangesHeight = (callback) => {
	const checkWindowHeightChanges = () => {
		let newWinHeight =
			typeof document.body.offsetHeight !== "undefined" ? document.body.offsetHeight : window.innerHeight;
		if (newWinHeight !== intWinHeight) {
			intWinHeight = newWinHeight;
			callback(); // Page height changed, trigger code!
		}
		loop++;
		if (loop > 120)
			// 500 * 120 = Stop after 60 seconds
			clearInterval(interval);
	};
	let loop = 0;
	let intWinHeight =
		typeof document.body.offsetHeight !== "undefined" ? document.body.offsetHeight : window.innerHeight;
	console.log("setInterval pageTracking");
	let interval = setInterval(checkWindowHeightChanges, 500);
};

const setupTestElement = (pageObject, triggerPath, text, triggerUrl, tracking, useTealiumTracking) => {
	let returnElements = null;
	let isComponentTest = pageObject[config.vuePageObject].testType === 1;
	let element = searchLib.findClickTrackingElements(triggerPath, text, triggerUrl, isComponentTest);
	console.log("A/B Test trigger element: ", element);
	if (isComponentTest) {
		let comp = searchLib.findClosestSectionParent(element);
		let links = searchLib.findAllLinkChildren(comp);
		console.log("Component A/B Test for: ", comp);
		console.log("Component links found:", links);
		setupClickTracking(links, tracking, useTealiumTracking, pageObject);
		if (links.length > 0) returnElements = links;
	} else if (element) {
		// Normal link tracking
		setupClickTracking([element], tracking, useTealiumTracking, pageObject);
		returnElements = element;
	}
	visualDebugger(returnElements, pageObject[config.vuePageObject]); // Display tracking status to editors
	return returnElements;
};

let init = function (pageObject, adobeTracking, useTealiumTracking = true) {
	if (!pageObject[config.vuePageObject]) {
		console.log("No AB test found");
		return false;
	}

	let tracking = JSON.parse(JSON.stringify(adobeTracking));
	// Page view tracking
	if (useTealiumTracking)
		// Tracking through Tealium and Analytics.
		!window.utag
			? tealiumLoad(adobeTracking, pageObject[config.vuePageObject], tealiumTrackingModel)
			: tealiumTrackingModel(adobeTracking, pageObject[config.vuePageObject]);
	//else { // Tracking through own server - Scrapped but might use later (if group needs it)
	// axios.post(config.customTrackingServer+"/view", customTrackingModel(pageObject[config.vuePageObject], false));
	//}

	if (pageObject[config.vuePageObject].testType !== 2) {
		let triggerUrl = pageObject[config.vuePageObject].trigger.href;
		let cleanUp = cleanUpPathAndText(pageObject[config.vuePageObject].trigger.path);
		let triggerPath = cleanUp.triggerPath;
		let text = cleanUp.text;

		detectPageChangesHeight(() => {
			setupTestElement(pageObject, triggerPath, text, triggerUrl, tracking, useTealiumTracking);
		});

		setupTestElement(pageObject, triggerPath, text, triggerUrl, tracking, useTealiumTracking);
		document.onclick = function () {
			// Check again everytime a new click is done. might be hidden elements on page (like a link inside a dropdown menu)
			setTimeout(() => {
				setupTestElement(pageObject, triggerPath, text, triggerUrl, tracking, useTealiumTracking);
			}, 100);
		};
	}
};

export default {
	init,
};
